//GeneratorFlag:[NoChange]
import NoticePattern from './notice-pattern';

export default {NoticePattern}
export{NoticePattern}